var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-utility',{attrs:{"isActive":_vm.showPanel}},[_c('PathwayMetadata',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPathwayPanel),expression:"showPathwayPanel"}]}),_c('NodeMetadata',{directives:[{name:"show",rawName:"v-show",value:(_vm.showNodePanel),expression:"showNodePanel"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }